import { getDataFromPocket } from '../../utils/pocket';
import { sleep } from '../../utils/promise';

interface VWOOptions {
    pollInterval: number;
    pollMaxAttempts: number;
}

export async function getVWOOutcome(): Promise<'regular' | 'pending' | 'redirect'> {
    const vwoOpts = getDataFromPocket<VWOOptions>('vwo_opts', false);

    if (!vwoOpts) {
        return window.VWO_OUTCOME;
    }

    for (let i = 0; i < vwoOpts.pollMaxAttempts; i++) {
        if (window.VWO_OUTCOME === 'pending') {
            // eslint-disable-next-line no-await-in-loop
            await sleep(vwoOpts.pollInterval);
        } else {
            return window.VWO_OUTCOME;
        }
    }

    return window.VWO_OUTCOME;
}
